document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.infinite-scroll-trigger');
  if (!trigger) return;

  let isLoading = false;

  const observer = new IntersectionObserver(
    (entries) => {
      // isIntersecting is a boolean. If it's true, the element is in view.
      if (entries[0].isIntersecting && !isLoading) {
        loadMoreProducts();
      }
    },
    {
      rootMargin: '0px 0px 400px 0px', // Load 400px before the trigger is visible
    }
  );

  const loadMoreProducts = async () => {
    isLoading = true;
    const nextUrl = trigger.dataset.nextUrl;

    if (!nextUrl) {
      observer.disconnect(); // No more pages, so stop observing
      trigger.remove();
      return;
    }

    // Add loading class to show the CSS spinner
    trigger.classList.add('loading');

    try {
      // --- THIS IS THE CORRECTED LINE ---
      // We only need the nextUrl, which already has the correct path.
      // We just append the section_id to it.
      const urlToFetch = `${nextUrl}§ion_id=main-collection-product-grid`;
      // --- END OF CORRECTION ---
      
      const response = await fetch(urlToFetch);
      const text = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, 'text/html');

      const newProducts = html.querySelector('#product-grid');
      const newTrigger = html.querySelector('.infinite-scroll-trigger');

      if (newProducts && newProducts.innerHTML.trim().length > 0) {
        // Append new products to the existing grid
        document.querySelector('#product-grid').insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }

      // Update the trigger with the URL for the *next* page, or remove it if there are no more pages.
      if (newTrigger && newTrigger.dataset.nextUrl) {
        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
      } else {
        // This was the last page, so disconnect the observer and remove the trigger.
        observer.disconnect();
        trigger.remove();
      }
    } catch (error) {
      console.error('Error fetching next page:', error);
      // On error, remove the trigger to prevent further attempts.
      observer.disconnect();
      trigger.remove();
    } finally {
      isLoading = false;
      trigger.classList.remove('loading');
    }
  };

  // Start observing the trigger element
  observer.observe(trigger);
});